import styled from 'styled-components'

import Typography from '@material-ui/core/Typography'

import colors from '@galo-monitor/styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0%;
  padding: 0;
`

export const HeaderText = styled(Typography)`
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  padding-top: 12px;
  color: ${ colors.primary };
`

export const MainText = styled(Typography)`
  text-align: center;
  color: ${ colors.mutedText };
  font-size: 0.9rem;
  margin: 22px 0 15px;
`
